import { RefObject, useEffect, useRef } from 'react';

const useOutsideClick = (refs: RefObject<HTMLElement>[], onOutsideClick: () => void, enabled = true) => {
  const latest = useRef({ refs, onOutsideClick });
  latest.current = { refs, onOutsideClick };

  useEffect(() => {
    if (!enabled) return;

    const handleOutsideClick = (event: MouseEvent) => {
      const { refs, onOutsideClick } = latest.current;

      if (refs.some((ref) => ref.current?.contains(event.target as Node))) return;

      onOutsideClick();
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [enabled]);
};

export default useOutsideClick;
